import gql from 'graphql-tag';

export default gql`
  mutation deleteQueueMutation($input: RelayDeleteQueueQueueInput!) {
    deleteQueue(input: $input) {
      ids
    }
  }
`;
